export const DEFAULT_CARD_ADDRESS = 'default' as const;
